import { Scrollable } from 'components/scrollable'
import { ComponentType, useState } from 'react'
import { Button, Col, Container, Row } from 'reactstrap'
import styled from 'styled-components'
import { Admins } from '../admins'
import { Rents } from '../rents'
import { Sales } from '../sales'

const Wrapper = styled.div`
  padding: 64px 0 100px 0;
`

const Title = styled.h4`
  margin-bottom: 40px;
  font-size: 18px;
  font-weight: bold;
  line-height: 22px;
  text-align: center;
`

const ButtonList = styled(Scrollable)`
  padding: 0 20px;
  margin-bottom: 32px;
  display: flex;
  flex-wrap: nowrap;
  overflow: auto;

  button:last-of-type {
    position: relative;

    ::after {
      content: '';
      display: block;
      position: absolute;
      right: -20px;
      width: 20px;
      height: 1px;
    }
  }
`

export const Tabs: ComponentType = () => {
  const [tab, setTab] = useState('sales')

  return (
    <Wrapper>
      <Container>
        <Row>
          <Col>
            <Title>Directorio de Asesores Certificados</Title>
          </Col>
        </Row>
      </Container>
      <ButtonList>
        <Button color="tab" onClick={() => setTab('sales')} active={tab === 'sales'} className="text-nowrap">
          Equipo de Ventas
        </Button>
        <Button color="tab" onClick={() => setTab('rents')} active={tab === 'rents'} className="text-nowrap">
          Equipo de Rentas
        </Button>
        <Button color="tab" onClick={() => setTab('admins')} active={tab === 'admins'} className="text-nowrap">
          Equipo Administrativo
        </Button>
      </ButtonList>
      {tab === 'sales' && <Sales />}
      {tab === 'rents' && <Rents />}
      {tab === 'admins' && <Admins />}
    </Wrapper>
  )
}
